export let FormSize = /*#__PURE__*/function (FormSize) {
  FormSize["XL"] = "xl";
  FormSize["LG"] = "lg";
  FormSize["MD"] = "md";
  FormSize["SM"] = "sm";
  return FormSize;
}({});

// TODO add implementation in inputs like in loaders etc ...
// TODO propagate id, name, variant and className ...
// TODO change to enum